import { CLOSE_SVG } from '../../../assets';
import React from 'react';
var EditPopup = function (props) {
    return (React.createElement("div", { className: "dimBackground  " + (props.closed ? '' : 'dim'), onClick: function () {
            props.onClosed(true);
        } },
        React.createElement("div", { className: "EditPopup " + (props.className || '') + " " + (props.closed ? 'display-none' : ''), onClick: function (e) { return e.stopPropagation(); }, style: { maxWidth: props.maxWidth } },
            React.createElement("div", { className: 'btn-bar' },
                React.createElement("img", { className: "exit", src: CLOSE_SVG, alt: "close", onClick: function () { return props.onClosed(true); } })),
            props.title &&
                React.createElement("h1", { style: { textAlign: props.textAlign } }, props.title),
            props.children)));
};
export default EditPopup;
//# sourceMappingURL=EditPopup.js.map